'use client';

import { tsrShared } from '@/libs/ts-rest/ts-rest';
import { createOccupationRootsQueryOptions } from '@/modules/shared/contracts';
import type { OccupationRootsQueryOptions } from '@/modules/shared/contracts';

export const useOccupationRootsQuery = (options?: Partial<OccupationRootsQueryOptions>) => {
	const queryOptions = createOccupationRootsQueryOptions();

	return tsrShared.occupations.listRoots.useQuery({
		...queryOptions,
		...options,
	});
};
